import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import HtmlEditorWithPreview from "./HtmlEditorWithPreview";

// ✅ правильный путь из src/shared/components/email -> src/features/sales/api
import { emailApi } from "../../../features/sales/api/emailApi";

function BulkEmailModal({
  open,
  onClose,
  form,
  errors,
  sending,
  recipients,

  onChange,
  onRecipientChange,
  onSubmit,
}) {
  const { t } = useTranslation();

  // показывать селектор sender только если email.mode == "hybrid"
  const [allowSenderOverride, setAllowSenderOverride] = useState(false);

  useEffect(() => {
    if (!open) return;

    let cancelled = false;

    (async () => {
      try {
        const res = await emailApi.getMode();
        if (cancelled) return;

        const allow = !!res?.allow_sender_override;
        setAllowSenderOverride(allow);

        // если режим НЕ hybrid -> всегда auto
        if (!allow) {
          onChange?.("sender", "auto");
        } else {
          // если hybrid, но sender еще не задан — выставим auto
          if (!form?.sender) onChange?.("sender", "auto");
        }
      } catch (e) {
        if (cancelled) return;
        setAllowSenderOverride(false);
        onChange?.("sender", "auto");
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          {/* HEADER */}
          <div className="modal-header d-flex align-items-center justify-content-between">
            <h5 className="modal-title">
              {t("send_corporate_email") || "Send corporate email"}
            </h5>

            <div className="d-flex align-items-center gap-3">
              {/* ✅ показываем только когда режим hybrid */}
              {allowSenderOverride && (
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted small">
                    {t("email_sender") || "Sender"}
                  </span>

                  <select
                    className="form-select form-select-sm"
                    value={form?.sender || "auto"}
                    onChange={(e) => onChange?.("sender", e.target.value)}
                    disabled={sending}
                    style={{
                      width: 240,
                      backgroundColor: "rgba(0,0,0,0.25)",
                      color: "rgba(255,255,255,0.92)",
                      border: "1px solid rgba(255,255,255,0.12)",
                    }}
                  >
                    <option value="auto">
                      {t("sender_auto") || "Auto (by settings)"}
                    </option>
                    <option value="company">
                      {t("sender_company") || "Company (corporate)"}
                    </option>
                    <option value="employee">
                      {t("sender_employee") || "Employee (my account)"}
                    </option>
                  </select>
                </div>
              )}

              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
          </div>

          {/* BODY */}
          <div className="modal-body">
            <HtmlEditorWithPreview
              mode="bulk"
              form={form}
              errors={errors}
              sending={sending}
              recipients={recipients}
              onRecipientChange={onRecipientChange}
              onChange={onChange}
              onSubmit={onSubmit}
              onCancel={onClose}
              // ✅ чтобы в Advanced не было sender (он теперь в header)
              hideSenderInAdvanced={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BulkEmailModal;
